{
  "serviceMasterTableConfig": {
    "columns": [

      {
        "fieldName": "name",
        "displayName": "Service Name",
        "dataType": "STRING",
        "sortable": true
      },
      {
        "fieldName": "code",
        "displayName": "Service Code",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "120px"
        },
        "styleConfig": {
          "type": "badge"
        }
      },
      {
        "fieldName": "entityTypeLabel",
        "displayName": "Entity Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "80px"
        }
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "thStyleConfig": {
          "width": "80px"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "serviceType.name",
        "displayName": "Service Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "150px"
        }
      },
      {
        "fieldName": "createdDate",
        "displayName": "Created Date",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      }
    ]
  },

    "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      },
      {
        "name": "SERVICE_TYPE_EQUALS",
        "displayLabel": "Service Type",
        "dataType": "DROPDOWN",
        "options":[],
        "operatorToFilterMap": {
          "EQ": "SERVICE_TYPE_EQUALS"
        }
      },
      {
        "name": "ENTITY_TYPE_EQUALS",
        "displayLabel": "Entity Type",
        "dataType": "DROPDOWN",
        "options":[],
        "operatorToFilterMap": {
          "EQ": "ENTITY_TYPE_EQUALS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Service by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "service_name"
      }
    ]
  }
}
